import "babel-polyfill";

import {binder, fwa} from "./libs/binder";
import {constants} from "./modules/module";
import "./libs/jcf.js";
import "./libs/slick.js";


import {customSelect} from "./modules/customSelect";
import {Popup} from "./modules/popup";
import {footerToggle} from "./modules/footerToggle";
import {infoSlider} from "./modules/infoSlider";
import {tabs} from "./modules/tabs";
import {headerActions} from "./modules/headerActions";
import {fullHeightPage} from "./modules/fullHeightPage";
import {successClose} from "./modules/successClose";
import {reservationsSlider} from "./modules/reservationsSlider";
import {bannerWithAnimation} from "./modules/bannerWithAnimation";
import {gradientCardAccardion} from "./modules/gradientCardAccardion";
import {bannerWithParallax} from "./modules/bannerWithParallax";
import {faqToggle} from "./modules/faqToggle";
import {customScroll} from "./modules/customScroll";
import {googleMap} from "./modules/googleMap";
import {videoOnScroll} from "./modules/videoOnScroll";
import {testimonialsSlider} from "./modules/testimonialsSlider";
import {timeline} from "./modules/timeline";
import {sliderSection} from "./modules/sliderSection";
import {copyLink} from "./modules/copyLink";
import {clearFIlter} from "./modules/clearFIlter";
import {fullHeightTestimonials} from "./modules/fullHeightTestimonials";
import {logosSlider} from "./modules/logosSlider";
import {widthAnimation} from "./modules/widthAnimation";
import {anchorNav} from "./modules/anchorNav";
import {infrastructureAvailable} from "./modules/infrastructureAvailable";
import {featuresSliderHolder} from "./modules/featuresSliderHolder";
import {stepsSlider} from "./modules/stepsSlider";
import {infoImageSlider} from "./modules/infoImageSlider";
import {animationOnScroll} from "./modules/animationOnScroll";
import {verticalSlider} from "./modules/verticalSlider";
import {spliterSlider} from "./modules/spliterSlider";
import {linkAnchor} from "./modules/linkAnchor";
import {solutionsSlider} from "./modules/solutionsSlider";
import {heroSection} from "./modules/heroSection";
import {ourMissionParallax} from "./modules/ourMissionParallax";
import {productAnimation} from "./modules/productAnimations";
import {getTouchAnimation} from "./modules/getTouchAnimation";
// import { filterScroll } from "./modules/filterScroll";
import {customZohoForm} from "./modules/zohoForm";

binder({
    bounds: {
        "html": [constants, fullHeightPage],
        "body": [Popup],
        ".header": headerActions,
        "select": customSelect,
        ".popup": Popup,
        "footer": footerToggle,
        ".info-slider": infoSlider,
        ".tabs": tabs,
        ".submit-form": successClose,
        ".reservations-slider": reservationsSlider,
        ".faq-section": faqToggle,
        ".jcf-scrollable": customScroll,
        ".map-holder": googleMap,
        ".has-video-animation": videoOnScroll,
        ".timeline-section": timeline,
        ".slider-section": sliderSection,
        ".copylink": copyLink,
        ".articles-controls": clearFIlter,
        ".banner-with-animation": bannerWithAnimation,
        ".gradient-cards-holder.opened-on-mobile": gradientCardAccardion,
        ".banner-with-parallax": bannerWithParallax,
        ".full-height-testimonials": fullHeightTestimonials,
        ".testimonials-slider-holder": testimonialsSlider,
        ".logos-slider": logosSlider,
        ".has-width-animation": widthAnimation,
        ".infrastructure-available": infrastructureAvailable,
        ".features-slider-holder": featuresSliderHolder,
        ".anchor-nav": anchorNav,
        ".steps-block": stepsSlider,
        ".info-image-slider": infoImageSlider,
        ".has-animation": animationOnScroll,
        ".vertical": verticalSlider,
        ".image-spliter": spliterSlider,
        ".page-title": linkAnchor,
        ".solutions-block": solutionsSlider,
        ".hero-section": heroSection,
        ".our-mission": ourMissionParallax,
        ".product-animation": productAnimation,
        ".get-touch-animation": getTouchAnimation,
        ".crmWebToEntityForm": customZohoForm,
    },
    runTests: false
});



// WEBPACK FOOTER //
// ./assets/js/global.js